import * as yup from 'yup';

export const AdministradorColumnList = (isAdmin) => {
   return [
      {
         id: 'administrador_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'administrador_nombres',
         dbname: 'nombres',
         label: 'nombres',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_apellidos',
         dbname: 'apellidos',
         label: 'apellidos',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_tipo_identificacion_id',
         dbname: 'tipo_identificacion_id',
         label: 'tipo_identificacion_id',
         visible: false,
         form: true,
         filter: true,
         align: 'right',
         foreign: {
            table: 'tipo_identificacion',
            label: 'tipo_identificacion',
            dbname: 'tipo_identificaciondesc',
            type: 'small'
         }
      },
      {
         id: 'administrador_documento',
         dbname: 'documento',
         label: 'documento',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_correo',
         dbname: 'correo',
         label: 'correo',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_telefono',
         dbname: 'telefono',
         label: 'telefono',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_direccion',
         dbname: 'direccion',
         label: 'direccion',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_ciudad',
         dbname: 'ciudad',
         label: 'ciudad',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_estado',
         dbname: 'estado',
         label: 'estado',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_pais',
         dbname: 'pais',
         label: 'pais',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_titulo_profesional',
         dbname: 'titulo_profesional',
         label: 'titulo_profesional',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'administrador_inicio_experiencia',
         dbname: 'inicio_experiencia',
         label: 'inicio_experiencia',
         visible: false,
         form: true,
         filter: true,
         type: 'date',
      },
      {
         id: 'administrador_certificaciones',
         dbname: 'certificaciones',
         label: 'certificaciones',
         visible: false,
         form: true,
         filter: true,
         type: 'text',
      },
      {
         id: 'administrador_comentarios',
         dbname: 'comentarios',
         label: 'comentarios',
         visible: false,
         form: true,
         filter: true,
         type: 'text',
      },
      {
         id: 'administrador_fecha_creacion',
         dbname: 'fecha_creacion',
         label: 'fecha_creacion',
         visible: true,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'administrador_fecha_actualizacion',
         dbname: 'fecha_actualizacion',
         label: 'fecha_actualizacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },

   ];
};

export const AdministradorValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombres: yup.string().nullable(),
      apellidos: yup.string().nullable(),
      tipo_identificacion_id: yup.number().nullable(),
      documento: yup.string().nullable(),
      correo: yup.string().nullable(),
      telefono: yup.string().nullable(),
      direccion: yup.string().nullable(),
      ciudad: yup.string().nullable(),
      estado: yup.string().nullable(),
      pais: yup.string().nullable(),
      titulo_profesional: yup.string().nullable(),
      inicio_experiencia: yup.date().nullable(),
      certificaciones: yup.string().nullable(),
      comentarios: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};

export const AdministradorFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombres: yup.string().nullable(),
      apellidos: yup.string().nullable(),
      tipo_identificacion_id: yup.number().nullable(),
      documento: yup.string().nullable(),
      correo: yup.string().nullable(),
      telefono: yup.string().nullable(),
      direccion: yup.string().nullable(),
      ciudad: yup.string().nullable(),
      estado: yup.string().nullable(),
      pais: yup.string().nullable(),
      titulo_profesional: yup.string().nullable(),
      inicio_experiencia: yup.date().nullable(),
      certificaciones: yup.string().nullable(),
      comentarios: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};